import React, { FC, ReactNode } from 'react';
import { Accordion } from 'flowbite-react';
import cx from 'classnames';
import { getMultilineEllipsisStyle } from '../PromptCard/utils/getMultilineEllipsisStyle';
import { ARTICLE_PARENT_INFO_CLASSNAMES } from './constants';

type TArticleParentInfoProps = {
  title: string;
  children?: ReactNode;
  isOpen?: boolean;
  onClick?: () => void;
  quotationMarks?: boolean;
};

export const ArticleParentInfo: FC<TArticleParentInfoProps> = ({
  title,
  children,
  isOpen,
  onClick,
  quotationMarks = false,
}) => (
  <Accordion collapseAll className="!rounded-[8px]">
    <Accordion.Panel>
      <Accordion.Title
        className={cx(
          'relative flex flex-row p-4 !text-sm text-t2-neutral-grey09 focus:ring-0 bg-transparent hover:bg-t2-neutral-grey03 !rounded-t-[7px]',
          {
            'hover:!rounded-[7px]': !isOpen,
          },
        )}
      >
        <div className="absolute inset-0 z-10 rounded-[8px]" onClick={onClick} />
        <div className="flex">
          <div className="relative flex pl-5 whitespace-nowrap w-fit before:absolute before:w-3 before:h-3 before:left-0 before:top-1/2 before:-translate-y-1/2 before:bg-curved-arrow-right before:bg-cover">
            Replied to:
          </div>
          <div
            className={cx('ml-1 pl-[5px] mr-6 pr-[6px] md:mr-12 multiline-ellipsis relative', {
              'invisible transition-all duration-300 opacity-0': isOpen,
              'visible transition-all duration-300 opacity-100': !isOpen,
              [ARTICLE_PARENT_INFO_CLASSNAMES.quotationMarks]: quotationMarks,
            })}
            style={{
              ...getMultilineEllipsisStyle(1),
            }}
          >
            {title}
          </div>
        </div>
      </Accordion.Title>
      <Accordion.Content
        className={cx('!border-t-0 p-0 grid grid-rows-[0fr] transition-all duration-500', {
          '!grid-rows-[1fr]': isOpen,
        })}
      >
        <div className="overflow-hidden">{children}</div>
      </Accordion.Content>
    </Accordion.Panel>
  </Accordion>
);
